/// <reference path="../../../Scripts/Public/jquery-1.6.2.min.js" />
/// <reference path="../../../Scripts/Public/AJAX.js" />
/// <reference path="../../../Scripts/Public/General.js" />
/// <reference path="../../../Scripts/Public/Security.js" />
/// <reference path="../../../Scripts/Public/ServiceURL.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('LiveTileControl.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('LiveTileControl.js requies the sumo.controls namespace defined in ControlBase.js');
}

// LiveTileControl Constructor Options (this.Options)
// Title: the primary text of the tile
// dataSourceName: the name of the data used to fill the tile - get the data from the cache
// IconUri: src for the image
// Destination: the destination uri of the tile click event
// NavigationType: is the destination a hash, or uri
//      valid values: 'hash', 'uri'
// RenderDirection: render horizontal or vertical
//      valid values: 'horitzontal', 'vertical'
// IsMultipleActions: respond to a tile wide click event,
//                    or to individual click events for each data element in dataset
// Cache: the cache with witch to subscribe for data updates
// StateManager: the state manager for the hash
// Formatter: allows generation of tile data by function call
/**
 * @class
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * @example
 * var  mStateManager = new SumoStateManager('mStateManager');
 * mControls.Tiles['uEnrolleesTile'] = new sumo.controls.LiveTileControl(
        'uEnrolleesTile',
        'uEnrolleesTileHolder',
        {
            'Title': localizeWrapper('cEnrollees'),
            'dataSourceName': 'EnrolleeTile',
            'IconUri': 'Images/EnrolleesLight40.png',
            'Destination': '#Enrollees.Offenders.Profile.Events',
            'NavigationType': 'hash',
            'RenderDirection': 'horizontal',
            'Cache': mCache,
            'StateManager': mStateManager,
            'ProcRequestMethod': GetEnrolleeTiles
        }
        );
 */
// used in Dashboard.js 
// mControls.Tiles['uEnrolleesTile'] = new sumo.controls.LiveTileControl
sumo.controls.LiveTileControl = function (aId, aParentId, aOptions) {
    "use strict";

    var mDataSource = null,
        mDataSourceName = '',
        mIsDirty = false,
        mIsVisible = true,
        mHtml = [
            '<table class="LiveTileControl" id="##id##" border="0" cellpadding="0" cellspacing="0">',
            ' <tr>',
            '    <td class="LiveTileControlIcon" id="##id##Icon"></td>',
            '    <td class="LiveTileControlData" id="##id##Data"></td>',
            ' </tr>',
            '<tr>',
            '    <td colspan="2" class="LiveTileControlTitle" id="##id##Title"></td>',
            '</tr>',
            '</table>'
        ];

    if (this.isNothing(aOptions)) {
        throw (this.className() + ': invalid call to constructor. no params passed to control id: ' + this.Id);
    }
    sumo.controls.LiveTileControl.prototype.baseClass.call(this, aId, aParentId, mHtml.join(''), aOptions);

    this.Title = '';
    this.IconUri = '';
    this.Destination = '';
    this.NavigationType = 'hash'; // valid values: 'hash', 'uri'
    this.RenderDirection = ''; // valid values: 'horitzontal', 'vertical'
    this.IsMultipleActions = false;
    this.Cache = null;
    this.StateManager = null;
    this.Formatter = null;
    this.CountMethod = null;
    this.ProcRequestMethod = null;

    if (!this.isNothing(aOptions.Cache)) {
        this.Cache = aOptions.Cache;
    } else {
        throw (this.className() + ': cache is required');
    }
    if (!this.isNothing(aOptions.StateManager)) {
        this.StateManager = aOptions.StateManager;
    } else {
        throw (this.className() + ': state manager is required');
    }
    if (!this.isNothing(aOptions.Title)) {
        this.Title = aOptions.Title;
    }
    if (!this.isNothing(aOptions.dataSourceName)) {
        mDataSourceName = aOptions.dataSourceName;
    }
    if (!this.isNothing(aOptions.IconUri)) {
        this.IconUri = aOptions.IconUri;
    }
    if (!this.isNothing(aOptions.Destination)) {
        this.Destination = aOptions.Destination;
    }
    if (!this.isNothing(aOptions.NavigationType)) {
        this.NavigationType = aOptions.NavigationType;
    }
    if (!this.isNothing(aOptions.RenderDirection)) {
        this.RenderDirection = aOptions.RenderDirection;
    }
    if (!this.isNothing(aOptions.IsMultipleActions)) {
        this.IsMultipleActions = aOptions.IsMultipleActions;
    }
    if (!this.isNothing(aOptions.Formatter)) {
        this.Formatter = aOptions.Formatter;
    }
    if (!this.isNothing(aOptions.CountMethod)) {
        this.CountMethod = aOptions.CountMethod;
    }
    if (!this.isNothing(aOptions.ProcRequestMethod)) {
        this.ProcRequestMethod = aOptions.ProcRequestMethod;
    }

    this.show = function () {
        if (!mIsVisible) {
            mIsVisible = true;
            if (mIsDirty) {
                dataBind(this);
            }
            $('#' + this.Id).show();
        }
    };

    this.hide = function () {
        if (mIsVisible) {
            mIsVisible = false;
            $('#' + this.Id).hide();
        }
    };

    function mControl_OnClick(aEvent) {
        var lThisElement = $(this),
            lThis = lThisElement.data('control');

        //alert(lThis.Destination);
        if (lThis.NavigationType === 'hash') {
            lThis.StateManager.ChangeHash(lThis.Destination);
        } else {
            window.location = lThis.Destination;
        }

        aEvent.stopPropagation();
    }

    function dataBind(aThis) {
        if (mIsDirty && !aThis.isNothing(mDataSource)) {
            var lNewDataSource = FixDataSource();

            var lKey,
                lItem,
                lInnerHtml = [],
                lSpace = '',
                lTileClass = '',
                lElement = $('#' + aThis.Id + 'Data');
            if (!aThis.isNothing(aThis.Formatter)) {
                lElement.html(aThis.Formatter(lNewDataSource));
                lElement.css('font-size', '20pt');
            } else if (!aThis.isNothing(lNewDataSource)) {
                if (count(lNewDataSource) > 1) {
                    $('#' + aThis.Id).addClass('LiveTileAdvanced');
                    for (lKey in lNewDataSource) {
                        if (lNewDataSource.hasOwnProperty(lKey)) {
                            lItem = lNewDataSource[lKey];
                            lInnerHtml.push('<div class="LiveTileRow" title="');
                            lInnerHtml.push(lItem.Name);
                            lInnerHtml.push('">');
                            if (lNewDataSource[lKey].Name !== "") {
                                lInnerHtml.push(localizeDataItem('', lItem.Name));
                                lSpace = ' ';
                            }
                            if (lNewDataSource[lKey].Value !== "") {
                                lInnerHtml.push(lSpace);
                                lInnerHtml.push(lItem.Value);
                            }
                            if (!aThis.isNothing(lItem.NavigationHash) && lItem.NavigationHash !== "") {
                                lInnerHtml.push('...');
                            }
                            lInnerHtml.push('</div>');
                        }
                    }
                    lElement.html(lInnerHtml.join(''));
                } else {
                    $('#' + aThis.Id).addClass('LiveTileBasic');
                    lElement.html('');
                    for (lKey in lNewDataSource) {
                        if (lNewDataSource.hasOwnProperty(lKey)) {
                            if (!aThis.isNothing(lNewDataSource[lKey])) {
                                lItem = lNewDataSource[lKey];
                                lInnerHtml.push('<span title="');
                                lInnerHtml.push(localizeDataItem('', lItem.Name));
                                lInnerHtml.push('">');
                                lInnerHtml.push(lItem.Value);
                                lInnerHtml.push('</span>');
                                lElement.html(lInnerHtml.join(''));
                                lElement.css('font-size', '20pt');
                                break;
                            }
                        }
                    }
                }
            }

            mIsDirty = false;

            aThis.trigger('databind');
        }
    }

    this.render = function () {
        this.ControlElement.find('#' + this.Id + 'Title').html(this.Title);
        this.ControlElement.click(mControl_OnClick);
        this.ControlElement.find('#' + this.Id + 'Icon').css('background-image', 'url(' + this.IconUri + ')');
        veritracks.localization.localize('#' + this.Id);
        this.trigger('render');
    };

    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (mIsVisible && !this.isNothing(mDataSource)) {
            dataBind(this);
        }
    };

    function procRequestCallback(aThis, aData){ 
        mDataSource = aData;
        mIsDirty = true;
        if (mIsVisible && mDataSource) {
            dataBind(aThis);
        }
    }

    function cache_onDataUpdated(aSender, aItem, aThis) {
        var lData = aItem.Data;
        if (!isNullOrUndefined(aThis.CountMethod)) {
            lData = aThis.CountMethod();
        }
        aThis.setDataSource(lData);
    }

    this.dispose = function () {
        this.Cache.unbind(mDataSourceName + 'updated', cache_onDataUpdated);

        this.ControlElement.unbind('click', mControl_OnClick);

        mDataSource = null;
        mHtml = null;

        sumo.controls.LiveTileControl.prototype.dispose.call(this);
    };

    function FixDataSource() {
        var lKey,
            lTemp,
            lTemp2,
            lHolder = [],
            lNewDataSource = [],
            i = 0,
            j = 0;
        if (!isNullOrUndefined(mDataSource)) {
            for (lKey in mDataSource) {
                if (mDataSource.hasOwnProperty(lKey)) {
                    lHolder.push(JSON.parse(JSON.stringify(mDataSource[lKey])));
                }
            }
            if (mDataSourceName !== "InventoryTile") {
                for (i = 0; i < ObjectLength(lHolder) ; i++) {
                    lTemp = parseInt(lHolder[i].Value);
                    for (j = 1; j < ObjectLength(lHolder) ; j++) {
                        if (i !== j) {
                            if (lHolder[i].Name == lHolder[j].Name) {
                                lTemp += parseInt(lHolder[j].Value);
                                lHolder.splice(j, 1);
                                j -= 1;
                                lHolder[i].Value = lTemp;
                            }
                        }
                    }
                    var liveTile = new Tile();
                    liveTile.OrganizationId = lHolder[i].OrganizationId;
                    liveTile.UserId = lHolder[i].UserId;
                    liveTile.Name = lHolder[i].Name;
                    liveTile.Value = lHolder[i].Value;
                    liveTile.NavigationHash = lHolder[i].NavigationHash;
                    lNewDataSource.push(liveTile);
                }
            }
            else {
                for (i = 0; i < ObjectLength(lHolder) ; i++) {
                    lTemp = parseInt(lHolder[i].Value);
                    lTemp2 = parseInt(lHolder[i].Value2);
                    for (j = 1; j < ObjectLength(lHolder) ; j++) {
                        if (i !== j) {
                            if (lHolder[i].Name == lHolder[j].Name) {
                                lTemp += parseInt(lHolder[j].Value);
                                if (parseInt(lHolder[j].Value2) > 0) {
                                    lTemp2 += parseInt(lHolder[j].Value2);
                                }
                                lHolder.splice(j, 1);
                                j -= 1;
                            }
                        }
                    }
                    if (lTemp2 > 0) {
                        lHolder[i].Value = ((lTemp / lTemp2) * 100).toFixed(2);
                    }
                    else {
                        lHolder[i].Value = lTemp;
                    }
                    var liveTile = new Tile();
                    liveTile.OrganizationId = lHolder[i].OrganizationId;
                    liveTile.UserId = lHolder[i].UserId;
                    liveTile.Name = lHolder[i].Name;
                    liveTile.Value = lHolder[i].Value;
                    liveTile.NavigationHash = lHolder[i].NavigationHash;
                    lNewDataSource.push(lHolder[i]);
                }
            }
        }
        return lNewDataSource;
    }

    this.Cache.bind(mDataSourceName + 'updated', cache_onDataUpdated, this);

    this.render();

    mDataSource = this.Cache.GetItem(mDataSourceName);
    if (!this.isNothing(mDataSource)) {
        if (!isNullOrUndefined(this.CountMethod)) {
            this.setDataSource(this.CountMethod());
        } else {
            this.setDataSource(mDataSource.Data);
        }
    }

    if (this.ProcRequestMethod) {
        this.ProcRequestMethod(procRequestCallback, null, this)
    }
};
sumo.controls.LiveTileControl.prototype = new sumo.controls.ControlBase();
sumo.controls.LiveTileControl.prototype.constructor = sumo.controls.LiveTileControl;
sumo.controls.LiveTileControl.prototype.baseClass = sumo.controls.ControlBase;